import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { selectUser } from '../../services/store/userSlice';
import moment from "moment";
import { Card } from "primereact/card";
import { trainingApi } from "../../services";
import { Button } from 'primereact/button';
import { confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { Dialog } from 'primereact/dialog';
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Editor } from 'primereact/editor';
import { Util } from '../../services';
import { typeOfTraining } from "../../common/util/constants";

const TrfDetailsView = ({ clickedRowData, type, reload, userRole }) => {
  const user = useSelector(selectUser);
  const [peerManagerView, setPeerManagerView] = useState(false);
  const [currentstatus, setCurrentstatus] = useState();
  const [appovalDialog, setAppovalDialog] = useState(false);
  const [rejectDialog, setRejectDialog] = useState(false);
  const [rejectRMDialog, setRejectRMDialog] = useState(false);
  const [trainingType, setTrainingType] = useState(null);
  const [activeTRF, setActiveTRF] = useState({});
  const [startDate, setStartDate] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [tRFTrainingId, setTRFTrainingId] = useState('');
  const [assesmentLink, setAssesmentLink] = useState('');
  const [feedbackLink, setFeedbackLink] = useState('');
  const [summary, setSummary] = useState(null);
  const [finalReport, setFinalReport] = useState(null);

  const [feedbackApprovalStatus, setFeedbackApprovalStatus] = useState(true);
  const [feedbackRejectedStatus, setFeedbackRejectedStatus] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    fetchEngagement();
    // const empIndex = user.roles.indexOf('PM');
    // setPeerManagerView(empIndex !== 1);
    const exists = user.roles.includes('PM');
        setPeerManagerView(exists);
  }, []);

  const fetchEngagement = () => {
    trainingApi.getEngagementTypes().then((resp) => {
      let proStatus = resp?.data?.data.find(item => item.id === clickedRowData?.status);
      setCurrentstatus(proStatus?.title);
    });
  };

  // const approveRejectEmpTRFRecord = (e, rowData, type) => {
  //   confirmDialog({
  //     target: e.currentTarget,
  //     message: `Are you sure you want to ${type} this record?`,
  //     header: 'Action Confirmation',
  //     icon: 'pi pi-info-circle',
  //     acceptClassName: "p-button-danger",
  //     acceptLabel: 'No',
  //     rejectLabel: 'Yes',
  //     reject: () => {
  //       var dataObj = [
  //         {
  //           status: type === "approve" ? 2 : 3,
  //           training: rowData?.id,
  //         },
  //       ];
  //       try {
  //         console.log(dataObj, "dataObjdataObjdataObj")
  //         trainingApi.updateApproveRejectTrainingForm11(dataObj).then(
  //           (resp) => {
  //             toast.success(resp?.data?.message);
  //             reload();
  //           },
  //           (err) => {
  //             toast.error(err.response.data.error);
  //           }
  //         );
  //       } catch (error) {
  //         toast.error("Unable to delete");
  //       }
  //     },
  //     accept: () => { }
  //   });
  // }


  const approveRejectEmpTRFRecord = (e, rowData, type) => {
    if (type === "approve") {
      confirmDialog({
        target: e.currentTarget,
        message: `Are you sure you want to ${type} this record?`,
        header: 'Action Confirmation',
        icon: 'pi pi-info-circle',
        acceptClassName: "p-button-danger",
        acceptLabel: 'No',
        rejectLabel: 'Yes',
        reject: () => {
          var dataObj = [
            {
              status: 2,
              training: rowData?.id,
            },
          ];
          try {
            console.log(dataObj, "dataObjdataObjdataObj")
            trainingApi.updateApproveRejectTrainingForm(dataObj).then(
              (resp) => {
                toast.success(resp?.data?.message);
                reload();
              },
              (err) => {
                toast.error(err.response.data.error);
              }
            );
          } catch (error) {
            toast.error("Unable to delete");
          }
        },
        accept: () => { }
      });
    } else {
      rejectionRMForm(rowData)
    }

  }

  const apporvalForm = (r) => {
    setTrainingType(null);
    setActiveTRF(r);
    var Training_startDate = new Date(r?.trainingRequisitionDate);
    if (Training_startDate) setStartDate(Training_startDate);
    var Training_endDate = new Date(r?.endDateOfTraining);
    if (Training_endDate) setEndDate(Training_endDate);
    setTrainingType(r?.trainingType)
    setAppovalDialog(true);
  }

  const rejectionForm = (r) => {
    setActiveTRF(r);
    var Training_startDate = new Date(r?.trainingRequisitionDate);
    if (Training_startDate) setStartDate(Training_startDate);
    var Training_endDate = new Date(r?.endDateOfTraining);
    if (Training_endDate) setEndDate(Training_endDate);
    setRejectDialog(true);
  }

  const rejectionRMForm = (r) => {
    setActiveTRF(r);
    var Training_startDate = new Date(r?.trainingRequisitionDate);
    if (Training_startDate) setStartDate(Training_startDate);
    var Training_endDate = new Date(r?.endDateOfTraining);
    if (Training_endDate) setEndDate(Training_endDate);
    setRejectRMDialog(true);
  }

  const renderHeader = () => {
    return (
      <span className="ql-formats">
        <button className="ql-bold" aria-label="Bold"></button>
        <button className="ql-italic" aria-label="Italic"></button>
        <button className="ql-underline" aria-label="Underline"></button>
      </span>
    );
  }

  const isCommentCheck = (val, type) => {
    if (type === "Approved") {
      if (val) {
        setFeedbackApprovalStatus(true);
        setFeedbackRejectedStatus(true);
        setIsValid(true);
      } else {
        setFeedbackApprovalStatus(false);
        setFeedbackRejectedStatus(false);
        setIsValid(false);
      }
    }

    if (type === "Rejection") {
      if (val) {
        setFeedbackRejectedStatus(true);
        setIsValid(true);
      } else {
        setFeedbackRejectedStatus(false);
        setIsValid(false);
      }
    }

  }

  const handleSubmit = (status) => {
    if (status === "Approved" && feedback == '') {
      setFeedbackApprovalStatus(false);
      setIsValid(false);
    } else {
      setFeedbackApprovalStatus(true);
      setIsValid(true);
    }

    if (status === "Rejection" && feedback == '') {
      setFeedbackRejectedStatus(false);
      setIsValid(false);
    } else {
      setFeedbackRejectedStatus(true);
      setIsValid(true);
    }
    var dataObj = [
      {
        reason: status === "Approved" ? "approve" : "reject",
        status: status === "Approved" ? 5 : 6,
        comments: Util.removeHtmlTags(feedback),
        trainingType: trainingType,
        endDateOfTraining: endDate,
        trainingRequisitionDate: startDate,
        assesment_link: assesmentLink,
        is_assessment: assesmentLink ? true : false,
        feedback_link: feedbackLink,
        is_feedback: feedbackLink ? true : false,
        training: activeTRF?.id,
        targetSkillName: activeTRF?.targetSkills?.title,
      },
    ];
    try {
      if (isValid) {
        trainingApi.updateApproveRejectTrainingForm(dataObj).then(
          (resp) => {
            toast.success(resp?.data?.message);
            setAppovalDialog(false);
            setRejectDialog(false);
            // setFeedbackDialog(false);
            setTimeout(() => {
              reload()
            }, 1000);
          },
          (err) => {
            toast.error(err.response.data.error);
          }
        );
      }
    } catch (error) {
      toast.error("Unable to update");
    }
  };


  const handleRMSubmit = (status) => {
    if (status === "Rejection" && feedback == '') {
      setFeedbackRejectedStatus(false);
      setIsValid(false);
    } else {
      setFeedbackRejectedStatus(true);
      setIsValid(true);
    }
    var dataObj = [
      {
        status: 3,
        training: activeTRF?.id,
      },
    ];
    try {
      if (isValid) {
        console.log(dataObj, "dataObjdataObjdataObj")
        trainingApi.updateApproveRejectTrainingForm(dataObj).then(
          (resp) => {
            toast.success(resp?.data?.message);
            reload();
          },
          (err) => {
            toast.error(err.response.data.error);
          }
        );
      }
    } catch (error) {
      toast.error("Unable to delete");
    }
  }


  const approvalDialog = () => {
    return (<>
      <Dialog header="TRF Approvals" visible={appovalDialog} style={{ width: '700px' }} onHide={() => { setAppovalDialog(false); setIsValid(false); setFeedback(''); }}>
        <div>
          <div className="flex flex-wrap p-field font-bold block">
            <div className="col-6">
              <label htmlFor="employeeName" disabled className="font-bold block mb-2 training-heading">Employee Name</label>
              <div className="p-inputgroup flex-1">
                <span className="p-inputgroup-addon">
                  <i className="pi pi-user"></i>
                </span>{" "}
                <InputText id="nominatedParticipant" disabled placeholder="Employee name" className="w-full" value={activeTRF?.nameOfNominatedParticipant} />
              </div>
            </div>
            <div className="col-6">
              <label htmlFor="trainingType" className="font-bold block mb-2 training-heading ">Training Type</label>
              <Dropdown id="trainingType" disabled className="w-full" value={trainingType} options={typeOfTraining} onChange={(e) => setTrainingType(e.value)} placeholder="Select Training Type" />
            </div>
          </div>

          <div className="flex flex-wrap p-field font-bold block">
            <div className="col-6">
              <label htmlFor="startDate" className="font-bold block mb-2 training-heading mt-2"> Start Date</label>
              <Calendar disabled id="startDate" value={startDate} onChange={(e) => setStartDate(e.value)} showIcon className="w-full requisition-date" placeholder="Enter Start Date" />
            </div>
            <div className="col-6">
              <label htmlFor="endDate" className="font-bold block mb-2 training-heading mt-2" >End Date</label>
              <Calendar disabled id="endDate" showIcon className="w-full requisition-date" placeholder="Enter End Date" value={endDate} onChange={(e) => setEndDate(e.value)} />
            </div>
            <div className="col-12">
              <label htmlFor="feedback" className="font-bold block mb-2 training-heading mt-2" >Notes</label>
              {/* <InputText name="comments" placeholder="Provide feedback" required style={{ background: "white" }} className="w-full" /> */}
              <Editor
                headerTemplate={renderHeader}
                style={{ height: '200px' }}
                placeholder="Provide feedback"
                id="feedback"
                value={feedback}
                onTextChange={(e) => { setFeedback(e.htmlValue ? e.htmlValue : ''); isCommentCheck(e.htmlValue, "Approved") }}
              />
            </div>
            {!feedbackApprovalStatus && (<span style={{ color: 'red' }}>Approval Note is Required!</span>)}
          </div>
        </div>

        <hr />
        <div className='' style={{ textAlign: 'right' }}>
          <Button label='Approve' icon='pi pi-check' severity='primary' className='mr-1' onClick={() => handleSubmit("Approved")} />
          <Button label='Cancel' icon='pi pi-times' severity='secondary' onClick={() => { setAppovalDialog(false); setIsValid(false); setFeedback(''); }} />
        </div>
      </Dialog>
    </>)
  }

  const rejectionDialog = () => {
    return (<>
      <Dialog header="TRF Rejection" visible={rejectDialog} style={{ width: '700px' }} onHide={() => { setRejectDialog(false); setIsValid(false); setFeedback(''); }}>
        <div>
          <h2>{activeTRF?.nameOfNominatedParticipant}</h2>
          <div className="flex flex-wrap p-field font-bold block">
            <div className="col-12">
              <label htmlFor="feedback" className="font-bold block mb-2 training-heading mt-2" >Rejection Note</label>
              {/* <InputText name="comments" placeholder="Provide feedback" required style={{ background: "white" }} className="w-full" /> */}
              <Editor headerTemplate={renderHeader} style={{ height: '200px' }} placeholder="Rejection Note" value={feedback} onTextChange={(e) => { setFeedback(e.htmlValue ? e.htmlValue : ''); isCommentCheck(e.htmlValue, "Rejection") }} />
            </div>
            {!feedbackRejectedStatus && (<span style={{ color: 'red' }}>Rejection Note is Required!</span>)}
          </div>
        </div>

        <hr />
        <div className='' style={{ textAlign: 'right' }}>
          <Button label='Reject' icon='pi pi-check' severity='primary' className='mr-1' onClick={() => handleSubmit("Rejection")} />
          <Button label='Cancel' icon='pi pi-times' severity='secondary' onClick={() => { setRejectDialog(false); setIsValid(false); setFeedback(''); }} />
        </div>
      </Dialog>
    </>)
  }

  const rejectionRMDialog = () => {
    return (<>
      <Dialog header="TRF Rejection" visible={rejectRMDialog} style={{ width: '700px' }} onHide={() => { setRejectRMDialog(false); setIsValid(false); setFeedback(''); }}>
        <div>
          <h2>{activeTRF?.nameOfNominatedParticipant}</h2>
          <div className="flex flex-wrap p-field font-bold block">
            <div className="col-12">
              <label htmlFor="feedback" className="font-bold block mb-2 training-heading mt-2" >Rejection Note</label>
              {/* <InputText name="comments" placeholder="Provide feedback" required style={{ background: "white" }} className="w-full" /> */}
              <Editor headerTemplate={renderHeader} style={{ height: '200px' }} placeholder="Rejection Note" value={feedback} onTextChange={(e) => { setFeedback(e.htmlValue ? e.htmlValue : ''); isCommentCheck(e.htmlValue, "Rejection") }} />
            </div>
            {!feedbackRejectedStatus && (<span style={{ color: 'red' }}>Rejection Note is Required!</span>)}
          </div>
        </div>

        <hr />
        <div className='' style={{ textAlign: 'right' }}>
          <Button label='Reject' icon='pi pi-check' severity='primary' className='mr-1' onClick={() => handleRMSubmit("Rejection")} />
          <Button label='Cancel' icon='pi pi-times' severity='secondary' onClick={() => { setRejectRMDialog(false); setIsValid(false); setFeedback(''); }} />
        </div>
      </Dialog>
    </>)
  }

  return (
    <>
      <hr />
      {!peerManagerView && (
        <div className="row">
          <div className="grid">
            <div className="col-3">
              <div className='col trf-Detail-Label'>Name Of Requester (RO) :</div>
              <div className='col'>
                {clickedRowData?.nameOfRequester ? clickedRowData?.nameOfRequester : '-'}
              </div>
            </div>

            <div className="col-3">
              <div className='col trf-Detail-Label'>ECN Of Requester :</div>
              <div className='col'>
                {clickedRowData?.ecnOfRequester ? clickedRowData?.ecnOfRequester : '-'}
              </div>
            </div>

            <div className="col-3">
              <div className='col trf-Detail-Label'>Business Unit / Function :</div>
              <div className='col'>
                {clickedRowData?.businessUnit ? clickedRowData?.businessUnit : '-'}
              </div>
            </div>

            <div className="col-3">
              <div className='col trf-Detail-Label'>Training Type :</div>
              <div className='col'>
                {clickedRowData?.trainingType ? clickedRowData?.trainingType : '-'}
              </div>
            </div>
          </div>
        </div>
      )}


      <div className="row mp-panel">
        <div className="grid">
          <div className="col-3">
            <div className='col trf-Detail-Label'>Participant Name :</div>
            <div className='col'>
              {clickedRowData?.nameOfNominatedParticipant ? clickedRowData?.nameOfNominatedParticipant : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Current Status Of Participant :</div>
            <div className='col'>
              {clickedRowData?.currentStatusOfNominatedResource == 1 ? 'Billable' : 'Non-Billable'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Project Name :</div>
            <div className='col'>
              {clickedRowData?.projectName ? clickedRowData?.projectName : '-'}
            </div>
          </div>

          {/* <div className="col-3">
            <div className='col trf-Detail-Label'>Current Technology :</div>
            <div className='col'>
              {clickedRowData?.currentTechnology ? clickedRowData?.currentTechnology : '-'}
            </div>
          </div> */}
          <div className="col-3">
            <div className='col trf-Detail-Label'>Target Skill :</div>
            <div className='col'>
              {clickedRowData?.targetSkills ? clickedRowData?.targetSkills?.title : '-'}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          {/* <div className="col-3">
            <div className='col trf-Detail-Label'>Target Skill :</div>
            <div className='col'>
              {clickedRowData?.targetSkills ? clickedRowData?.targetSkills?.title : '-'}
            </div>
          </div> */}

          <div className="col-3">
            <div className='col trf-Detail-Label'>Category Of Training :</div>
            <div className='col'>
              {clickedRowData?.categoryOfTrainings ? clickedRowData?.categoryOfTrainings?.title : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Training Requisition Date :</div>
            <div className='col'>
              {clickedRowData?.createdAt ? moment(clickedRowData?.createdAt).format("DD-MM-YYYY") : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Start Date for Training :</div>
            <div className='col'>
              {clickedRowData?.startDateOfTraining ? moment(clickedRowData?.startDateOfTraining).format("DD-MM-YYYY") : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>End Date for Training :</div>
            <div className='col'>
              {clickedRowData?.endDateOfTraining ? moment(clickedRowData?.endDateOfTraining).format("DD-MM-YYYY") : '-'}
            </div>
          </div>
        </div>
      </div>


      <div className="row mp-panel">
        <div className="grid">
          <div className="col-3">
            <div className='col trf-Detail-Label'>Training Assigned for Requested Project :</div>
            <div className='col'>
              {clickedRowData?.requestedTrainingProjectDetails?.title ? clickedRowData?.requestedTrainingProjectDetails?.title : '-'}
            </div>
          </div>
        </div>
      </div>


      <div className="row">
        <div className="grid">
          <div className="col-6">
            <div className='col trf-Detail-Label'>Current Skill Competency Level :</div>
            <div className='col'>
              {clickedRowData?.currentLevel ? clickedRowData?.currentLevel === 1 ? 'Beginner with no knowledge' : clickedRowData?.currentLevel === 2 ? 'Beginner with basic knowledge' : clickedRowData?.currentLevel === 3 ? 'Intermediate with good knowledge but no hands-on experience' : clickedRowData?.currentLevel === 4 ? 'Intermediate with strong hands-on experience' : clickedRowData?.currentLevel === 5 ? 'Expert' : '-' : '-'}
            </div>
          </div>

          <div className="col-6">
            <div className='col trf-Detail-Label'>Expected Skill Competency Level :</div>
            <div className='col'>
              {clickedRowData?.expectedLevel ? clickedRowData?.expectedLevel === 1 ? 'Beginner with no knowledge' : clickedRowData?.expectedLevel === 2 ? 'Beginner with basic knowledge' : clickedRowData?.expectedLevel === 3 ? 'Intermediate with good knowledge but no hands-on experience' : clickedRowData?.expectedLevel === 4 ? 'Intermediate with strong hands-on experience' : clickedRowData?.expectedLevel === 5 ? 'Expert' : '-' : '-'}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="col-6">
            <div className='col trf-Detail-Label'>Improvement Area(Comment) :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>{clickedRowData?.improvementAreaTriggeringTrainingNeed ? clickedRowData?.improvementAreaTriggeringTrainingNeed : '-'}</Card>
            </div>
          </div>
          <div className="col-6">
            <div className='col trf-Detail-Label'>Module-Specific Details :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>{clickedRowData?.moduleSpecificDetails ? clickedRowData?.moduleSpecificDetails : '-'}</Card>
            </div>
          </div>
        </div>
      </div>
      {type === 'approval' && userRole === 1 && (
        <div className="row">
          <div className="grid">
            <div className="col-4"></div>
            <div className="col-4">
              <Button className='p-button p-button-sm ess-table-button' severity='primary' icon="pi pi-check" label='Approve' onClick={(e) => approveRejectEmpTRFRecord(e, clickedRowData, 'approve')} />
              <Button className='p-button p-button-sm ess-table-button ml-4' severity='danger' icon="pi pi-times" label='Reject' onClick={(e) => approveRejectEmpTRFRecord(e, clickedRowData, 'reject')} />
            </div>
            <div className="col-4"></div>
          </div>
        </div>
      )}

      {type === 'approval' && userRole === 36 && (
        <div className="row">
          <div className="grid">
            <div className="col-4"></div>
            <div className="col-4">
              <Button className='p-button p-button-sm ess-table-button' severity='primary' icon="pi pi-check" label='Approve' onClick={() => apporvalForm(clickedRowData)} />
              <Button className='p-button p-button-sm ess-table-button ml-4' severity='danger' icon="pi pi-times" label='Reject' onClick={() => rejectionForm(clickedRowData)} />
            </div>
            <div className="col-4"></div>
          </div>
        </div>
      )}

      {approvalDialog()}
      {rejectionDialog()}
      {rejectionRMDialog()}
    </>
  )
}
export default TrfDetailsView;
